import type { FormSettings } from '@/components/interfaces/project-settings-view.interfaces.ts'
import { ProjectAIType, WidgetVisualPosition } from '@/enums.ts'

export const PROJECT_SETTINGS_FORM_SETTINGS: FormSettings = Object.freeze({
  widgetAssistant: {
    name: { minLength: 3, maxLength: 32 },
    badge: { minLength: 3, maxLength: 32 },
  },
  security: {
    banIpChatsLimitChats: { min: 0, max: 20, step: 1 },
    maxChatsPerTimeChats: { min: 5, max: 100, step: 5 },
    maxChatsPerTimeSeconds: { min: 60, max: 3600, step: 15 },
    aiQuitMessagesThreshold: { min: 3, max: 100, step: 1 },
    maxMessagesPerTimeSeconds: { min: 60, max: 3600, step: 60 },
    maxMessagesPerTimeMessages: { min: 50, max: 1000, step: 50 },
    maxChatMessagesPerTimeSeconds: { min: 0, max: 3600, step: 100 },
    banIpChatsLimitIntervalSeconds: { min: 0, max: 3600, step: 5 },
    maxChatMessagesPerTimeMessages: { min: 0, max: 1000, step: 100 },
    maxChatMessagesPerTimeBanMinutes: { min: 0, max: 1440, step: 10 },
    banIpChatsLimitIntervalBanTimeMinutes: { min: 0, max: 1440, step: 1 },
  },
  widgetVisual: {
    color: '#A27B50FF',
    avatarUrl: { minLength: 0, maxLength: 512 },
    gradients: {
      enabled: false,
      degree: { min: 0, max: 360, step: 1 },
      colors: ['#A27B50FF', '#B79891FF'],
    },
    margins: {
      horizontalPx: { min: 0, max: 100, step: 1 },
      verticalPx: { min: 0, max: 100, step: 1 },
      position: WidgetVisualPosition.Right,
    },
  },
  common: {
    chatAliveForXMinutes: { min: 0, max: 14400, step: 60 },
  },
  widgetAssistantBehaviour: {
    initialMessage: { minLength: 0, maxLength: 128 },
    delayBeforeResponseMs: { min: 0, max: 20000, step: 100 },
    initialMessageTypingDelayMs: { min: 0, max: 20000, step: 100 },
    initialMessageSendingDelayAfterTypingEndedMs: { min: 0, max: 10000, step: 100 },
  },
  /* widgetLocalization: {
    default: false,
    locale: WidgetLocale.EN,
    assistantName: {minLength: 3, maxLength: 32},
    assistantBadge: {minLength: 3, maxLength: 32},
    initialMessage: {minLength: 0, maxLength: 128},
    userMessagePlaceholder: {minLength: 3, maxLength: 32},
  }, */
  ai: {
    type: ProjectAIType.ChatGPTRegular,
    chatGptInitialTask: { minLength: 0, maxLength: 2048 },
  }
})
